import { render, staticRenderFns } from "./AdminRecordTable.vue?vue&type=template&id=8a57b4e0&scoped=true&"
import script from "./AdminRecordTable.vue?vue&type=script&lang=js&"
export * from "./AdminRecordTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminRecordTable.vue?vue&type=style&index=0&id=8a57b4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a57b4e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCheckbox,VPagination})
